import React from "react";
import {arePackagesWaitingForServerAck, getPackageUID, PACKAGE_STATES} from "../../../../lib/WarehouseHelper";
import IdleActions from "./_1_IdleActions";
import PickingActions from "./_2_PickingActions";
import PackingActions from "./_3_PackingActions";
import PackedActions from "./_4_PackedActions";
import LoadedActions from "./_5_LoadedActions";
import FulfilledActions from "./_6_FulfilledActions";
import styles from "./PackageActions.module.scss";
import {List} from "immutable";


const PackageActions = (props) => {
  const { pack, jobId } = props;

  if (jobId) {
    return <JobActions {...props} />
  }
  
  const active = !arePackagesWaitingForServerAck([pack]);
  let actions;

  switch (pack.get("state")) {
    case PACKAGE_STATES.DUE_TO_PROCESS:
      actions = <IdleActions {...props} active={active} />;
      break;
    
    case PACKAGE_STATES.PICK:
      actions = <PickingActions {...props} active={active} />;
      break;
    
    case PACKAGE_STATES.PACK:
      actions = <PackingActions {...props} active={active} />;
      break;
    
    case PACKAGE_STATES.PICKUP_READY:
      actions = <PackedActions {...props} active={active} />;
      break;
    
    case PACKAGE_STATES.IN_TRANSIT:
      actions = <LoadedActions {...props} active={active} />;
      break;
    
    case PACKAGE_STATES.FULFILLED:
      actions = <FulfilledActions {...props} active={active} />;
      break;
    
    default:
      console.log("No action defined for package " + getPackageUID(pack) + " and state " + pack.get("state"));
      actions = null;
  }

  const classes = [
    styles.module,
    active ? styles.active : styles.inactive,
  ];
  
  return (
    <div className={classes.join(" ")}>
      { actions }
    </div>
  );
}

// Use in OrderWithPackages to display job specific actions
function JobActions(props) {
  const { packages } = props;

  const active = !arePackagesWaitingForServerAck(packages);
  let actions = null;
  if (packages.every((p) => p.get("state") === PACKAGE_STATES.DUE_TO_PROCESS) && props.detailView) {
    actions = (
      <IdleActions key={PACKAGE_STATES.DUE_TO_PROCESS}
        {...props}
        active={active}
        jobIds={List([props.jobId])}
      />
    );
  } else if (packages.every((p) => p.get("state") === PACKAGE_STATES.PICK)) {
    actions = <PickingActions key={PACKAGE_STATES.PICK} {...props} active={active} />;
  } else if (packages.every((p) => p.get("state") === PACKAGE_STATES.PACK)) {
    actions = <PackingActions key={PACKAGE_STATES.PACK} {...props} active={active} />;
  } else if (packages.every((p) => p.get("state") === PACKAGE_STATES.PICKUP_READY)) {
    actions = <PackedActions key={PACKAGE_STATES.PICKUP_READY} {...props} active={active} />;
  } else if (packages.every((p) => p.get("state") === PACKAGE_STATES.IN_TRANSIT)) {
    actions = <LoadedActions key={PACKAGE_STATES.IN_TRANSIT} {...props} active={active} />;
  }

  const classes = [
    styles.headerActions,
    active ? styles.active : styles.inactive,
  ];
  
  return actions && (
    <div className={classes.join(" ")}>
      { actions }
    </div>
  );
}

export default PackageActions;